import React, { useMemo } from 'react';

const Particles = () => {
  const particles = useMemo(
    () =>
      Array.from({ length: 18 }, (_, i) => ({
        id:      i,
        size:    Math.random() * 2.5 + 0.8,
        left:    `${Math.random() * 100}%`,
        delay:   `${Math.random() * 8}s`,
        duration:`${Math.random() * 10 + 10}s`,
        opacity: Math.random() * 0.35 + 0.08,
      })),
    []
  );

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            bottom: '-20px',
            left: p.left,
            width: p.size,
            height: p.size,
            borderRadius: '50%',
            background: `rgba(201,162,39,${p.opacity})`,
            animation: `particleUp ${p.duration} ${p.delay} infinite linear`,
          }}
        />
      ))}
    </div>
  );
};

export default Particles;
